<template>
  <div>
    <slot name="label"></slot>
    <input
      id="user_email"
      v-model="name"
      :placeholder="placeholder"
      name="user[email]"
      required="required"
      class="form-control"
      autofocus
    />
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "UserFormEmailField",
  props: {
    placeholder: {
      required: true,
      type: String,
    },
    value: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      name: this.value,
    };
  },
  watch: {
    name(val) {
      this.setEmailAddress(val);
    },
  },
  methods: {
    ...mapActions({
      setEmailAddress: "userForm/setEmailAddress",
    }),
  },
};
</script>
